export default "__VITE_ASSET__rvfziGCN__"